import React from 'react';

export function supportsShapePattern(spec) {
  if (!('spec_version' in spec) && !('scene_type' in spec)) {
    const symbols = typeof spec.sequence === 'string' ? spec.sequence.split(',').map((s) => s.trim()) : [];
    return symbols.length === 6 && symbols.at(-1) === '?' && symbols.slice(0, -1).every((s) => ['▲', '■', '⬟'].includes(s));
  }
  const { terms, hidden_index: hidden } = spec;
  if (spec.spec_version !== '2.0' || !Array.isArray(terms) || terms.length !== 4
    || !Number.isInteger(hidden) || hidden < 0 || hidden >= 4 || terms.some((t) => !t || typeof t !== 'object')
    || spec.answer_highlight !== false) return false;
  if (spec.scene_type === 'polygon_side_pattern') {
    return spec.display_side_count_labels === false && terms.every((t, i) => i === hidden
      ? t.kind === 'placeholder' && t.sides == null
      : t.kind === 'regular_polygon' && Number.isInteger(t.sides) && t.sides >= 3 && t.sides <= 12);
  }
  const { symbol, symbol_value: value } = spec;
  const step = spec.pattern_rule?.step;
  if (spec.scene_type !== 'shape_number_pattern' || !['▲', '■', '⬟'].includes(symbol)
    || !Number.isInteger(value) || value < 1 || value > 10 || ![-1, 1].includes(step)) return false;
  let start;
  const valid = terms.every((t, i) => {
    if (i === hidden) return t.hidden === true && t.symbol_count == null && t.displayed_value == null && !t.symbols;
    const count = t.symbol_count;
    if (t.hidden !== false || !Number.isInteger(count) || count < 1 || count > 5
      || t.symbols !== symbol.repeat(count) || !Number.isInteger(t.displayed_value) || t.displayed_value !== value * count) return false;
    if (start === undefined) start = count - i * step;
    return count === start + i * step;
  });
  return valid && start + hidden * step >= 1 && start + hidden * step <= 5;
}

function Polygon({ sides, x, y, radius }) {
  const points = Array.from({ length: sides }, (_, i) => {
    const a = -Math.PI / 2 + i * 2 * Math.PI / sides;
    return `${x + radius * Math.cos(a)},${y + radius * Math.sin(a)}`;
  }).join(' ');
  return <polygon points={points} fill="#2563eb" />;
}

function Symbol({ symbol, x, y }) {
  return symbol === '■' ? <rect x={x - 8} y={y - 8} width="16" height="16" rx="1" fill="#2563eb" />
    : <Polygon sides={symbol === '▲' ? 3 : 5} x={x} y={y} radius={10} />;
}

export default function ShapePatternVisual(spec) {
  const numberPattern = spec.scene_type === 'shape_number_pattern';
  return <>
    {numberPattern && spec.show_value_legend && <g><Symbol symbol={spec.symbol} x={265} y={38} /><text x="320" y="47" fontSize="26">= {spec.symbol_value}</text></g>}
    {spec.terms.map((term, i) => {
      const x = 75 + i * 150;
      const hidden = i === spec.hidden_index;
      return <g key={term.id || i} data-testid={`pattern-term-${i}`}>
        <rect x={x - 65} y="70" width="130" height="165" rx="14" fill={hidden ? '#fff7ed' : '#eff6ff'} stroke={hidden ? '#f97316' : '#bfdbfe'} strokeWidth="2" strokeDasharray={hidden ? '6 5' : undefined} />
        {hidden ? <text x={x} y="164" fontSize="48">?</text> : numberPattern ? <>
          {Array.from({ length: term.symbol_count }, (_, j) => <Symbol key={j} symbol={spec.symbol} x={x + (j - (term.symbol_count - 1) / 2) * 23} y={132} />)}
          <text x={x} y="207" fontSize="30">{term.displayed_value}</text>
        </> : <Polygon sides={term.sides} x={x} y={150} radius={40} />}
      </g>;
    })}
  </>;
}
